import Axios from '../Axios';

const customer = {
	create(data) {
		return Axios.post('/consumers', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/consumers?&limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/consumers/' + id);
	},
	update(id, data) {
		return Axios.put('/consumers/' + id, data);
	},
	delete(id) {
		return Axios.delete('/consumers/' + id);
	},
};

export default customer;
